import React from "react";
import { Handle, Position } from "@xyflow/react";
import { cn } from "@/lib/utils";
import type { HandleProps } from "./types";

interface CustomHandleProps extends HandleProps {
  style: React.CSSProperties;
}

export const CustomHandle: React.FC<CustomHandleProps> = ({
  type,
  position,
  id,
  label,
  style,
}) => {
  return (
    <>
      <Handle
        type={type}
        position={position}
        id={id}
        className="w-1 h-6 !bg-primary hover:!border-foreground"
        style={style}
      />
      {label && (
        <span
          className={cn(
            "absolute text-sm text-gray-500 text-primary",
            position === Position.Left
              ? "left-0 -translate-x-[calc(100%+8px)] -translate-y-[50%]"
              : "right-0 translate-x-[calc(100%+8px)] -translate-y-[50%]",
          )}
          style={style}
        >
          {label}
        </span>
      )}
    </>
  );
};
